<template>
  <div class="position-relative">
    <div v-if="loading" class="bpm-overlay">
      <span class="indicator-progress d-flex flex-column align-items-center text-success">
        <span class="spinner-border spinner-border-lg mb-2" aria-hidden="true"></span>
        <span>Подождите...</span>
      </span>
    </div>
    <div class="row">
      <!-- <div class="col-md-4">
        <button
          class="btn btn-lg btn-outline-primary w-100 d-flex flex-column align-items-center justify-content-center border border-gray-300 bpm-kdp-btn h-150px h-md-200px mb-3 mb-md-0"
          :disabled="loading"
          @click="sendKdp(1)"
        >
          <i class="ki-duotone ki-file fs-7x fs-md-5x text-success p-0 m-0">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span class="indicator-label mt-2">Бумажный</span>
        </button>
      </div> -->
      <div class="col-md-6">
        <button
          class="btn btn-lg btn-outline-primary w-100 d-flex flex-column align-items-center justify-content-center border border-gray-300 bpm-kdp-btn h-150px h-md-200px mb-3 mb-md-0"
          :disabled="loading"
          @click="sendKdp(2)"
        >
          <i class="ki-duotone ki-shield fs-7x fs-md-5x text-success p-0 m-0">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span class="indicator-label mt-2">1414</span>
        </button>
      </div>
      <div class="col-md-6">
        <button
          class="btn btn-lg btn-outline-primary w-100 d-flex flex-column align-items-center justify-content-center border border-gray-300 bpm-kdp-btn h-150px h-md-200px mb-3 mb-md-0"
          :disabled="loading"
          @click="sendKdp(3)"
        >
          <i class="ki-duotone ki-phone fs-7x fs-md-5x text-success p-0 m-0">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <span class="indicator-label mt-2">ОТП</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ProcessBpmModal',
  components: {
  },
  props: {
    process: {
      type: Object,
      required: true
    }
  },
  emits: ['update-process', 'close-modal'],
  data() {
    return {
      loading: false
    }
  },
  methods: {
    sendKdp(kdp) {
      if (this.loading) return
      this.loading = true
      const params = {
        id: this.process.process_data.id,
        data: kdp
      }
      axios.post('/api/v2/process/bpm/send', params)
        .then(res => {
          if (res.data.result) {
            this.$emit('update-process', res.data.data, this.process.id)
            this.$emit('close-modal')
          } else {
            this.$notifyError(res.data)
          }
        })
        .catch(err => {
          this.$notifyError(err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.bpm-kdp-btn.btn-outline-primary:hover {
  border-color: var(--bs-success) !important;
  background-color: transparent !important;
}
.bpm-overlay {
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 0.475rem;
  min-height: 200px;
}
</style>